import { useMutation } from '@apollo/client'
import {
  BookkeepersCompanyIncidenceStatsDocument,
  BookkeepersManagementUpdateIncidenceMessageStatusDocument,
} from 'generated/resources/graphql'

import type { MESSAGE_SENDER } from 'modules/bookkeepers/store/models/Incidence'

interface QueryParameters {
  incidenceId: number
  hasMessage: boolean
  messageFrom?: keyof typeof MESSAGE_SENDER
}

export const useUpdateIncidenceMessageStatus = () => {
  const [updateIncidenceMessageStatus, { loading }] = useMutation(
    BookkeepersManagementUpdateIncidenceMessageStatusDocument,
    {
      refetchQueries: [BookkeepersCompanyIncidenceStatsDocument],
    }
  )

  return {
    update(params: QueryParameters) {
      return updateIncidenceMessageStatus({ variables: params })
    },
    loading,
  }
}
